import React, { useEffect } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction } from '../service'

import { FormProvider, useForm } from 'react-hook-form'
import { FormMenuItemLookup, SuggestItem, SuggestType } from '../components/menu-item-lookup'

interface EditOrderFormItem {
  item_name: SuggestItem
  menu_name: string
  category_name: string
  price: number
  quantity: number
}

export function AddItem(props: { onClose: () => void; onSave: (action: EditOrderAction) => void }): JSX.Element {
  const form = useForm<EditOrderFormItem>({
    mode: 'onBlur',
    defaultValues: {
      menu_name: 'Menu',
      category_name: 'Adjusted Items',
      price: 0,
      quantity: 0,
    },
  })

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = form

  const itemName = watch('item_name')

  useEffect(() => {
    if (itemName && itemName.kind === SuggestType.MenuItem) {
      setValue('price', itemName.price)
    }
  }, [itemName])

  const validateAndSave = (data: EditOrderFormItem): void => {
    const payload = {
      price: data.price,
      quantity: data.quantity,
      total: data.price * data.quantity,
    }
    switch (data.item_name.kind) {
      case SuggestType.NewItem:
        props.onSave({
          op: 'add-item',
          item: {
            ...payload,
            item_name: data.item_name.name,
            category_name: data.category_name,
            menu_name: data.menu_name,
          },
        })
        break
      case SuggestType.MenuItem:
        props.onSave({
          op: 'add-item',
          item: {
            ...payload,
            item_id: data.item_name.id,
            item_name: data.item_name.name,
            category_id: data.item_name.categoryId,
            category_name: data.item_name.categoryName,
            menu_id: data.item_name.menuId,
            menu_name: data.item_name.menuName,
          },
        })
    }

    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Add Item</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <FormProvider {...form}>
            <FormMenuItemLookup name="item_name" />
          </FormProvider>
          <div className="form-group">
            <label htmlFor="price">Price:</label>
            <input
              id="price"
              className="form-control input input-small"
              style={errors && errors.price ? { color: 'red' } : {}}
              type="number"
              step={0.01}
              {...register('price', {
                required: 'is required',
                valueAsNumber: true,
              })}
            />
            {errors && errors.price && <span className="text-danger">{errors.price.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="quantity">Quantity:</label>
            <input
              id="quantity"
              className="form-control input input-small"
              style={errors && errors.quantity ? { color: 'red' } : {}}
              type="number"
              step={1}
              {...register('quantity', {
                required: 'is required',
                min: { value: 1, message: 'must be greater than 0' },
                valueAsNumber: true,
              })}
            />
            {errors && errors.quantity && <span className="text-danger">{errors.quantity.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
